import type {TFunction} from 'i18next';
import {z} from 'zod';

export const form270Schema = (t: TFunction<'translation', undefined>) =>
    z.object({
        allergies: z.coerce
            .string({message: `${t('requiredErrorFull')}`})
            .transform(str => str === 'true')
            .nullable(),
        asthma: z.coerce
            .string({message: `${t('requiredErrorFull')}`})
            .transform(str => str === 'true')
            .nullable(),
        diabetes: z.coerce
            .string({message: `${t('requiredErrorFull')}`})
            .transform(str => str === 'true')
            .nullable(),
        gTubeFeeding: z.coerce
            .string({message: `${t('requiredErrorFull')}`})
            .transform(str => str === 'true')
            .nullable(),
        seizures: z.coerce
            .string({message: `${t('requiredErrorFull')}`})
            .transform(str => str === 'true')
            .nullable(),
    });
